import { FileDown } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { US, TN, AE } from 'country-flag-icons/react/3x2'
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="bg-gradient-to-b from-black to-gray-900 text-white py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                    {/* Brand Block */}
                    <div className="flex flex-col">
                        <div className="relative p-6 border border-gray-700 rounded-xl shadow-lg bg-gradient-to-br from-gray-900 to-black overflow-hidden hover:border-gray-600 transition-all duration-300">
                            <div className="flex justify-end space-x-3 mb-4">
                                <Link to="https://www.instagram.com/2k.events/?hl=fr" target="_blank" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110">
                                    <FaInstagram size={20} />
                                </Link>
                                <Link to="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110">
                                    <FaFacebook size={20} />
                                </Link>
                                <Link to="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110">
                                    <FaTwitter size={20} />
                                </Link>
                                <Link to="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110">
                                    <FaLinkedin size={20} />
                                </Link>
                            </div>

                            <h3 className="font-serif text-2xl text-white tracking-wide mb-3">2k Events Group</h3>
                            <p className="text-gray-400 text-xs leading-relaxed mb-4">
                                {t('2k Events is a premier event management company based in the United Arab Emirates and Tunisia, offering top-notch services in wedding planning, decoration, and catering. Specializing in creating memorable events, they provide a wide range of tailored services for weddings, corporate functions, and private celebrations.')}
                            </p>

                            <div className="space-y-2">
                                <p className="font-semibold text-xs flex items-center hover:text-white transition-colors duration-300">
                                    <AE className="inline-block h-3 w-5 mr-2" /> 
                                    <span className="text-gray-400 hover:text-white">📞 (+971) 52 938 5968</span>
                                </p>
                                <p className="font-semibold text-xs flex items-center hover:text-white transition-colors duration-300">
                                    <TN className="inline-block h-3 w-5 mr-2" /> 
                                    <span className="text-gray-400 hover:text-white">📞 +(216) 20 004 777</span>
                                </p>
                                <p className="text-xs flex items-center hover:text-white transition-colors duration-300">
                                    ✉️ <span className="text-gray-400 hover:text-white ml-1">contact@2kevents.ae</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="flex flex-col">
                        <h6 className="text-white font-semibold text-lg mb-3 uppercase tracking-wider">Quick Links</h6>
                        <ul className="space-y-2">
                            <li>
                                <HashLink 
                                    to="#about" 
                                    className="text-gray-400 hover:text-white transition-all duration-300 flex items-center group text-sm"
                                >
                                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2 group-hover:bg-white transition-colors duration-300"></span>
                                    Intro
                                </HashLink>
                            </li>
                            <li>
                                <HashLink 
                                    to="/#services" 
                                    className="text-gray-400 hover:text-white transition-all duration-300 flex items-center group text-sm"
                                >
                                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2 group-hover:bg-white transition-colors duration-300"></span>
                                    Projects
                                </HashLink>
                            </li>
                            <li>
                                <HashLink 
                                    to="/AroundWorld" 
                                    className="text-gray-400 hover:text-white transition-all duration-300 flex items-center group text-sm"
                                >
                                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2 group-hover:bg-white transition-colors duration-300"></span>
                                    About Us
                                </HashLink>
                            </li>
                            <li>
                                <HashLink 
                                    to="/blog" 
                                    className="text-gray-400 hover:text-white transition-all duration-300 flex items-center group text-sm"
                                >
                                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2 group-hover:bg-white transition-colors duration-300"></span>
                                    Wedding Blog
                                </HashLink>
                            </li>
                        </ul>
                    </div>

                    {/* Location */}
                    <div className="flex flex-col">
                        <h6 className="text-white font-semibold text-lg mb-3 uppercase tracking-wider">Visit Us</h6>
                        <div className="space-y-2">
                            <div className="p-3 border border-gray-700 rounded-lg hover:border-gray-600 transition-all duration-300">
                                <p className="text-gray-400 text-xs flex items-center">
                                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2"></span>
                                    Dubai, 14th Floor, Blue Bay Tower - Business Bay
                                </p>
                            </div>
                            <div className="p-3 border border-gray-700 rounded-lg hover:border-gray-600 transition-all duration-300">
                                <p className="text-gray-400 text-xs flex items-center">
                                    <span className="w-1.5 h-1.5 bg-gray-600 rounded-full mr-2"></span>
                                    Tunisie, Ennaser 2
                                </p>
                            </div>
                        </div>
                        <div className="mt-4 w-full h-40 rounded-lg overflow-hidden shadow-lg border border-gray-700 hover:border-gray-600 transition-all duration-300">
                            <iframe
                                className="w-full h-full"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.2796639216426!2d55.27078247578987!3d25.20484998383638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4347179dfebf%3A0x48a8b4a70a7a6a1d!2sBurj%20Khalifa!5e0!3m2!1sen!2sae!4v1622634751289!5m2!1sen!2sae"
                                loading="lazy"
                                title="Map location"
                            ></iframe>
                        </div>
                    </div>
                </div>

                {/* PDF Download Section */}
                <div className="mt-8 border-t border-gray-700 pt-6 text-center">
                    <a
                        href="/2kpd.pdf"
                        download="2k-Brochure.pdf"
                        className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-700 hover:to-gray-800 rounded-lg text-xs font-medium transition-all duration-300 group shadow-md hover:shadow-lg"
                    >
                        <FileDown
                            size={16}
                            className="mr-2 group-hover:-translate-y-1 transition-transform duration-300"
                        />
                        Download Brochure
                    </a>
                </div>

                {/* Bottom Section - Social & Copyright */}
                <div className="mt-6 border-t border-gray-700 pt-4 flex flex-col-reverse md:flex-row items-center justify-between gap-4">
                    <p className="text-gray-500 text-xs tracking-wide">
                        © {new Date().getFullYear()} Eternal Moments. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;